import { IOption } from '../models/ICommon';

export const nearDeadlineOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Template A' },
  { id: 1, value: 'Template B' },
  { id: 2, value: 'Template C' },
  { id: 3, value: 'Template D' },
  { id: 4, value: 'Template E' },
  { id: 5, value: 'Template F' },
];

export const deadlineCrossOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Template A' },
  { id: 1, value: 'Template B' },
  { id: 2, value: 'Template C' },
  { id: 3, value: 'Template D' },
  { id: 4, value: 'Template E' },
  { id: 5, value: 'Template F' },
];

export const regularModeOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Template A' },
  { id: 1, value: 'Template B' },
  { id: 2, value: 'Template C' },
  { id: 3, value: 'Template D' },
  { id: 4, value: 'Template E' },
  { id: 5, value: 'Template F' },
];

// export const allProcessOptions1: IReactSelectOption[] = [
//   { label: "-1", value: 'please_select', isDisabled: true },
//   { label: "0", value: 'Template A' },
//   { label: "1", value: 'Template B' },
//   { label: "2", value: 'Template C' },
//   { label: "3", value: 'Template D' },
//   { label: "4", value: 'Template E' },
//   { label: "5", value: 'Template F' },
// ];

export const allProcessOptions1 = {
  Process: [
    {
      id: 1,
      processName: 'Process A',
      deliveryDueDate: '2025-01-15',
    },
    {
      id: 2,
      processName: 'Process B',
      deliveryDueDate: '2025-02-10',
    },
  ],
};

export const allProcessOptions2 = [
  {
    id: -1,
    value: 'please_select',
    disabled: true,
  },
  {
    id: 1,
    value: 'Test',
  },
  {
    id: 2,
    value: 'Long comment process',
  },
  {
    id: 3,
    value: 'A very very long name process A very very long name process',
  },
  {
    id: 4,
    value: 'Test 1',
  },
  {
    id: 5,
    value: 'Test 2',
  },
  {
    id: 6,
    value: 'Test 3',
  },
  {
    id: 7,
    value: 'Test 4',
  },
];

export const mockTemplateData = [
  {
    TemplateId: 1,
    TemplateName: 'User Registration',
    comment: 'Template for user registration process.',
  },
  {
    TemplateId: 2,
    TemplateName: 'Order Confirmation',
    comment: 'Template for order confirmation emails.',
  },
  {
    TemplateId: 3,
    TemplateName: 'Password Reset',
    comment: 'Template for password reset instructions.',
  },
  {
    TemplateId: 4,
    TemplateName: 'Feedback Request',
    comment: 'Template used for gathering user feedback.',
  },
  {
    TemplateId: 5,
    TemplateName: 'Subscription Renewal',
    comment: 'Template for notifying users about subscription renewal.',
  },
];

export const mockHolidayCalendarData = [
  {
    Id: 1,
    Date: '2025-01-03',
    Day: 'Friday',
    Category: 'Work',
    Comment: 'Completed project tasks',
  },
  {
    Id: 2,
    Date: '2025-01-02',
    Day: 'Thursday',
    Category: 'Personal',
    Comment: 'Went grocery shopping',
  },
  {
    Id: 3,
    Date: '2025-01-01',
    Day: 'Wednesday',
    Category: 'Holiday',
    Comment: 'Celebrated New Year',
  },
  {
    Id: 4,
    Date: '2024-12-31',
    Day: 'Tuesday',
    Category: 'Work',
    Comment: 'Prepared year-end report',
  },
  {
    Id: 5,
    Date: '2024-12-30',
    Day: 'Monday',
    Category: 'Leisure',
    Comment: 'Watched a movie',
  },
];

export const allProcessesSteps = [
  {
    Id: 21,
    Item: '正しいトルク値で締め付けられているか',
    Reference: 'Picture 0',
    Type: false,
  },
  {
    Id: 22,
    Item: 'ラベル内容、配線、半挿入、ひげ有無',
    Reference: 'Picture 0',
    Type: true,
  },
  {
    Id: 23,
    Item: '測長した数字が公差範囲に入っているか',
    Reference: 'Picture 0',
    Type: false,
  },
  {
    Id: 24,
    Item: '型式の確認',
    Reference: 'Picture 0',
    Type: true,
  },
  {
    Id: 25,
    Item: 'ラインマークの確認',
    Reference: 'Picture 0',
    Type: false,
  },
  {
    Id: 26,
    Item: '正しいトルク値で締め付けられているか',
    Reference: 'Picture 0',
    Type: true,
  },
  {
    Id: 27,
    Item: 'タイラップ、ラベル取り付け向き',
    Reference: 'Picture 0',
    Type: false,
  },
];

export const allProcessImages = [
  {
    Images:
      'https://plus.unsplash.com/premium_photo-1701015911181-d42783752d43?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    Id: 8,
    ProcessId: 10,
  },
  {
    Images:
      'https://images.unsplash.com/photo-1738494610271-46cc1ee41886?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    Id: 81,
    ProcessId: 10,
  },
  {
    Images:
      'https://plus.unsplash.com/premium_photo-1701015911181-d42783752d43?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    Id: 811,
    ProcessId: 10,
  },
  {
    Images:
      'https://images.unsplash.com/photo-1738494610271-46cc1ee41886?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    Id: 8111,
    ProcessId: 10,
  },
];

export const mockGroupNames: IOption[] = [
  { id: -1, value: 'please_select', disabled: true },
  { id: 0, value: 'Group A' },
  { id: 1, value: 'Group B' },
  { id: 2, value: 'Group C', disabled: true },
];

/** Mock response for GET /ToolManagement (GetAllToolManagementList) */
export const mockToolManagementListResponse = {
  Error: false,
  Message: '',
  Data: {
    PagingDetails: {
      TotalRecords: 8,
      TotalPages: 1,
      CurrentPage: 1,
      PageSize: 10,
    },
    Tools: [
      {
        ToolId: 1,
        ToolManagementNo: 'DID-3-1007',
        ToolName: 'CAS196000',
        OwnerFactoryId: 57,
        ToolManufacturer: 'AMP',
        ToolModel: 'CAS196000',
        SerialNo: 'SN-00123',
        EquipmentCategory: 'crimping_tool',
        ProcessUsed: 'Production Process',
        UsageStatus: 0,
        InspectionStatus: 0,
        InspectionFormat: 0,
        InspectionInterval: null,
        InspectionCycle: 0,
        CalibrationStatus: 0,
        CalibrationExpiryDate: '2027-03-31',
        PurchaseDate: '2023-04-01',
        DisposalDate: null,
        Location: '北陸工場 1F',
        ManagingDepartment: '製造部',
        ResponsibleManager: '山田太郎',
        FixedAssetNo: 'FA-00123',
        TagId: '175150',
        TeachmebizUrl: '',
        Remarks: '',
        IsActive: true,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'AMP',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 1,
        CreatedAt: '2023-04-01T09:00:00',
        UpdatedBy: 1,
        UpdatedAt: '2023-04-01T09:00:00',
        CrimpRows: [
          { Id: 1, RowIndex: 0, AWG: '16', LowerLimitCH: 1.55, UpperLimitCH: 1.65, TensileStrengthLimit: 110 },
          { Id: 2, RowIndex: 1, AWG: '18', LowerLimitCH: 1.28, UpperLimitCH: 1.38, TensileStrengthLimit: 85 },
          { Id: 3, RowIndex: 2, AWG: '20', LowerLimitCH: 1.01, UpperLimitCH: 1.11, TensileStrengthLimit: 60 },
          { Id: 4, RowIndex: 3, AWG: '22', LowerLimitCH: 0.89, UpperLimitCH: 0.99, TensileStrengthLimit: 45 },
          { Id: 5, RowIndex: 4, AWG: '24', LowerLimitCH: 0.75, UpperLimitCH: 0.85, TensileStrengthLimit: 30 },
        ],
      },
      {
        ToolId: 2,
        ToolManagementNo: 'DID-3-1008',
        ToolName: 'CAS196000',
        OwnerFactoryId: 50,
        ToolManufacturer: 'AMP',
        ToolModel: 'CAS196000',
        SerialNo: 'SN-00124',
        EquipmentCategory: 'crimping_tool',
        ProcessUsed: 'Production Process',
        UsageStatus: 0,
        InspectionStatus: 0,
        InspectionFormat: 0,
        InspectionInterval: null,
        InspectionCycle: 0,
        CalibrationStatus: 0,
        CalibrationExpiryDate: '2027-03-31',
        PurchaseDate: '2023-04-01',
        DisposalDate: null,
        Location: '北陸工場 1F',
        ManagingDepartment: '製造部',
        ResponsibleManager: '山田太郎',
        FixedAssetNo: 'FA-00124',
        TagId: '175151',
        TeachmebizUrl: '',
        Remarks: '',
        IsActive: true,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'AMP',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 1,
        CreatedAt: '2023-04-01T09:00:00',
        UpdatedBy: 1,
        UpdatedAt: '2023-04-01T09:00:00',
      },
      {
        ToolId: 3,
        ToolManagementNo: 'DID-3-1012',
        ToolName: 'CAS810600',
        OwnerFactoryId: 50,
        ToolManufacturer: 'AMP',
        ToolModel: 'CAS810600',
        SerialNo: 'SN-00201',
        EquipmentCategory: 'crimping_tool',
        ProcessUsed: 'Production Process',
        UsageStatus: 1,
        InspectionStatus: 0,
        InspectionFormat: 0,
        InspectionInterval: null,
        InspectionCycle: 0,
        CalibrationStatus: 1,
        CalibrationExpiryDate: '2026-12-31',
        PurchaseDate: '2023-06-15',
        DisposalDate: null,
        Location: '北陸工場 1F',
        ManagingDepartment: '製造部',
        ResponsibleManager: '佐藤花子',
        FixedAssetNo: 'FA-00201',
        TagId: '175152',
        TeachmebizUrl: '',
        Remarks: '貸出中のため確認要',
        IsActive: true,
        LoanFactoryId: 2,
        LoanDate: '2026-05-28',
        LoanRecord: 1,
        PlannedReturnDate: '2026-06-05',
        PartsManufacturer: 'AMP',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 1,
        CreatedAt: '2023-06-15T09:00:00',
        UpdatedBy: 1,
        UpdatedAt: '2026-05-28T09:00:00',
      },
      {
        ToolId: 4,
        ToolManagementNo: 'DID-5-8007',
        ToolName: 'YAD-4A',
        OwnerFactoryId: 50,
        ToolManufacturer: 'JST',
        ToolModel: 'YAD-4A',
        SerialNo: 'SN-00301',
        EquipmentCategory: 'pneumatic_tool',
        ProcessUsed: 'Production Process',
        UsageStatus: 2,
        InspectionStatus: 0,
        InspectionFormat: 1,
        InspectionInterval: null,
        InspectionCycle: 0,
        CalibrationStatus: 0,
        CalibrationExpiryDate: '2028-06-30',
        PurchaseDate: '2024-01-10',
        DisposalDate: null,
        Location: '北陸工場 2F',
        ManagingDepartment: '製造部',
        ResponsibleManager: '山田太郎',
        FixedAssetNo: 'FA-00301',
        TagId: '175153',
        TeachmebizUrl: '',
        Remarks: '',
        IsActive: true,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'JST',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 1,
        CreatedAt: '2024-01-10T09:00:00',
        UpdatedBy: 1,
        UpdatedAt: '2024-01-10T09:00:00',
        InspectionTabs: [
          {
            TabIndex: 0,
            Title: 'Air Pressure Check',
            Images: [],
            CheckItems: [
              { Id: 1, CheckItemMessage: 'Air pressure gauge reading (Measured Value MPa)', IsChecked: false, HeaderTitle: 'Air Pressure Check' },
              { Id: 2, CheckItemMessage: 'No visible air leaks from hose fittings', IsChecked: false, HeaderTitle: 'Air Pressure Check' },
            ],
          },
          {
            TabIndex: 1,
            Title: 'Blade Condition',
            Images: [],
            CheckItems: [
              { Id: 3, CheckItemMessage: 'Blade edge free of chips/cracks', IsChecked: false, HeaderTitle: 'Blade Condition' },
              { Id: 4, CheckItemMessage: 'Blade alignment within tolerance (Measured Value mm)', IsChecked: false, HeaderTitle: 'Blade Condition' },
            ],
          },
        ],
      },
      {
        ToolId: 5,
        ToolManagementNo: 'DID-5-8136',
        ToolName: '206-1204',
        OwnerFactoryId: 50,
        ToolManufacturer: 'Ferrule社',
        ToolModel: '206-1204',
        SerialNo: 'SN-00401',
        EquipmentCategory: 'ferrule_tool',
        ProcessUsed: 'Production Process',
        UsageStatus: 3,
        InspectionStatus: 1,
        InspectionFormat: 0,
        InspectionInterval: 30,
        InspectionCycle: 2,
        CalibrationStatus: 2,
        CalibrationExpiryDate: '2025-12-31',
        PurchaseDate: '2021-02-20',
        DisposalDate: null,
        Location: '北陸工場 1F',
        ManagingDepartment: '製造部',
        ResponsibleManager: '佐藤花子',
        FixedAssetNo: 'FA-00401',
        TagId: '175154',
        TeachmebizUrl: '',
        Remarks: '校正期限切れのため使用不可',
        IsActive: true,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'Ferrule社',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 1,
        CreatedAt: '2021-02-20T09:00:00',
        UpdatedBy: 1,
        UpdatedAt: '2025-12-31T09:00:00',
      },
      {
        ToolId: 6,
        ToolManagementNo: 'DID-3-1020',
        ToolName: 'CAS220100',
        OwnerFactoryId: 2,
        ToolManufacturer: 'AMP',
        ToolModel: 'CAS220100',
        SerialNo: 'SN-00512',
        EquipmentCategory: 'crimping_tool',
        ProcessUsed: 'Production Process',
        UsageStatus: 0,
        InspectionStatus: 0,
        InspectionFormat: 0,
        InspectionInterval: null,
        InspectionCycle: 1,
        CalibrationStatus: 0,
        CalibrationExpiryDate: '2027-09-30',
        PurchaseDate: '2022-11-05',
        DisposalDate: null,
        Location: '東海工場 1F',
        ManagingDepartment: '品質管理部',
        ResponsibleManager: '鈴木一郎',
        FixedAssetNo: 'FA-00512',
        TagId: '175160',
        TeachmebizUrl: '',
        Remarks: '',
        IsActive: true,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'AMP',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 2,
        CreatedAt: '2022-11-05T09:00:00',
        UpdatedBy: 2,
        UpdatedAt: '2022-11-05T09:00:00',
      },
      {
        ToolId: 7,
        ToolManagementNo: 'DID-6-9004',
        ToolName: 'Reel Feeder 3000',
        OwnerFactoryId: 2,
        ToolManufacturer: 'Molex',
        ToolModel: 'RF-3000',
        SerialNo: 'SN-00789',
        EquipmentCategory: 'measuring_tool',
        ProcessUsed: 'Testing',
        UsageStatus: 0,
        InspectionStatus: 0,
        InspectionFormat: 1,
        InspectionInterval: 90,
        InspectionCycle: 2,
        CalibrationStatus: 0,
        CalibrationExpiryDate: '2026-10-15',
        PurchaseDate: '2023-09-01',
        DisposalDate: null,
        Location: '東海工場 2F',
        ManagingDepartment: '製造部',
        ResponsibleManager: '鈴木一郎',
        FixedAssetNo: 'FA-00789',
        TagId: '175161',
        TeachmebizUrl: 'https://teachme.biz/example/reel-feeder-3000',
        Remarks: '',
        IsActive: true,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'Molex',
        ReelModel: 'RM-500',
        LooseTerminalModel: '',
        CreatedBy: 2,
        CreatedAt: '2023-09-01T09:00:00',
        UpdatedBy: 2,
        UpdatedAt: '2023-09-01T09:00:00',
      },
      {
        ToolId: 8,
        ToolManagementNo: 'DID-3-1099',
        ToolName: 'CAS900500',
        OwnerFactoryId: 50,
        ToolManufacturer: 'AMP',
        ToolModel: 'CAS900500',
        SerialNo: 'SN-00915',
        EquipmentCategory: 'other',
        ProcessUsed: null,
        UsageStatus: 2,
        InspectionStatus: 1,
        InspectionFormat: 0,
        InspectionInterval: 365,
        InspectionCycle: 2,
        CalibrationStatus: 2,
        CalibrationExpiryDate: '2024-05-31',
        PurchaseDate: '2019-03-12',
        DisposalDate: '2024-06-01',
        Location: '北陸工場 倉庫',
        ManagingDepartment: '製造部',
        ResponsibleManager: '山田太郎',
        FixedAssetNo: 'FA-00915',
        TagId: '175162',
        TeachmebizUrl: '',
        Remarks: '廃棄済み',
        IsActive: false,
        LoanFactoryId: 0,
        LoanDate: null,
        LoanRecord: 0,
        PlannedReturnDate: null,
        PartsManufacturer: 'AMP',
        ReelModel: '',
        LooseTerminalModel: '',
        CreatedBy: 1,
        CreatedAt: '2019-03-12T09:00:00',
        UpdatedBy: 1,
        UpdatedAt: '2024-06-01T09:00:00',
      },
    ],
  },
};


export const dummyResponse = {
  NonConformanceResponseList: [
    {
      Id: 1001,
      TrayId: 50001,
      TrayName: "TRAY-50001",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 101,
      DetectedByName: "John Smith",
      DetectedOn: "2026-08-13T09:30:00+05:30",
      Katashiki: "ABC-12345",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 102,
      NcApprovedOn: "2026-08-13T10:00:00+05:30",
      WorkApprovedBy: 103,
      WorkApprovedOn: "2026-08-13T11:30:00+05:30",
      CorrectionTime: 45,
      NonConformanceItems: [
        {
          Id: 1,
          Subject: "Wire",
          Item: "Terminal",
          BomInfo: "BOM-10001",
          DefectiveItemCount: 2,
          DefectDetail: "Terminal crimping is not proper"
        },
        {
          Id: 2,
          Subject: "Cable",
          Item: "Insulation",
          BomInfo: "BOM-10002",
          DefectiveItemCount: 1,
          DefectDetail: "Insulation damage found"
        }
      ]
    },
    {
      Id: 1002,
      TrayId: 50002,
      TrayName: "TRAY-50002",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 105,
      DetectedByName: "David Kumar",
      DetectedOn: "2026-08-13T08:45:00+05:30",
      Katashiki: "XYZ-78901",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 106,
      NcApprovedOn: "2026-08-13T09:15:00+05:30",
      WorkApprovedBy: 107,
      WorkApprovedOn: "2026-08-13T10:45:00+05:30",
      CorrectionTime: 30,
      NonConformanceItems: [
        {
          Id: 3,
          Subject: "Connector",
          Item: "Housing",
          BomInfo: "BOM-20001",
          DefectiveItemCount: 3,
          DefectDetail: "Connector housing is cracked"
        }
      ]
    },
    {
      Id: 1003,
      TrayId: 50003,
      TrayName: "TRAY-50003",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 110,
      DetectedByName: "Michael Lee",
      DetectedOn: "2026-08-12T15:20:00+05:30",
      Katashiki: "LMN-45678",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 111,
      NcApprovedOn: "2026-08-12T16:00:00+05:30",
      WorkApprovedBy: 112,
      WorkApprovedOn: "2026-08-12T17:10:00+05:30",
      CorrectionTime: 60,
      NonConformanceItems: [
        {
          Id: 4,
          Subject: "Wire",
          Item: "Conductor",
          BomInfo: "BOM-30001",
          DefectiveItemCount: 1,
          DefectDetail: "Conductor continuity failure"
        },
        {
          Id: 5,
          Subject: "Terminal",
          Item: "Crimp",
          BomInfo: "BOM-30002",
          DefectiveItemCount: 2,
          DefectDetail: "Incorrect crimp height"
        }
      ]
    },
    {
      Id: 1004,
      TrayId: 50004,
      TrayName: "TRAY-50004",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 115,
      DetectedByName: "Robert Wilson",
      DetectedOn: "2026-08-12T14:10:00+05:30",
      Katashiki: "ABC-23456",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 116,
      NcApprovedOn: "2026-08-12T14:45:00+05:30",
      WorkApprovedBy: 117,
      WorkApprovedOn: "2026-08-12T16:00:00+05:30",
      CorrectionTime: 35,
      NonConformanceItems: [
        {
          Id: 6,
          Subject: "Cable",
          Item: "Jacket",
          BomInfo: "BOM-10003",
          DefectiveItemCount: 2,
          DefectDetail: "Cable jacket cut detected"
        }
      ]
    },
    {
      Id: 1005,
      TrayId: 50005,
      TrayName: "TRAY-50005",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 120,
      DetectedByName: "Sarah Johnson",
      DetectedOn: "2026-08-12T13:25:00+05:30",
      Katashiki: "XYZ-89012",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 121,
      NcApprovedOn: "2026-08-12T14:00:00+05:30",
      WorkApprovedBy: 122,
      WorkApprovedOn: "2026-08-12T15:20:00+05:30",
      CorrectionTime: 50,
      NonConformanceItems: [
        {
          Id: 7,
          Subject: "Connector",
          Item: "Pin",
          BomInfo: "BOM-20002",
          DefectiveItemCount: 4,
          DefectDetail: "Connector pin bent"
        }
      ]
    },
    {
      Id: 1006,
      TrayId: 50006,
      TrayName: "TRAY-50006",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 125,
      DetectedByName: "James Anderson",
      DetectedOn: "2026-08-12T11:40:00+05:30",
      Katashiki: "LMN-56789",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 126,
      NcApprovedOn: "2026-08-12T12:15:00+05:30",
      WorkApprovedBy: 127,
      WorkApprovedOn: "2026-08-12T13:30:00+05:30",
      CorrectionTime: 70,
      NonConformanceItems: [
        {
          Id: 8,
          Subject: "Wire",
          Item: "Conductor",
          BomInfo: "BOM-30003",
          DefectiveItemCount: 2,
          DefectDetail: "Open circuit detected"
        },
        {
          Id: 9,
          Subject: "Cable",
          Item: "Shield",
          BomInfo: "BOM-30004",
          DefectiveItemCount: 1,
          DefectDetail: "Shielding is damaged"
        }
      ]
    },
    {
      Id: 1007,
      TrayId: 50007,
      TrayName: "TRAY-50007",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 130,
      DetectedByName: "Emily Davis",
      DetectedOn: "2026-08-11T16:15:00+05:30",
      Katashiki: "ABC-34567",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 131,
      NcApprovedOn: "2026-08-11T16:50:00+05:30",
      WorkApprovedBy: 132,
      WorkApprovedOn: "2026-08-11T18:00:00+05:30",
      CorrectionTime: 40,
      NonConformanceItems: [
        {
          Id: 10,
          Subject: "Wire",
          Item: "Terminal",
          BomInfo: "BOM-10004",
          DefectiveItemCount: 1,
          DefectDetail: "Terminal not locked properly"
        }
      ]
    },
    {
      Id: 1008,
      TrayId: 50008,
      TrayName: "TRAY-50008",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 135,
      DetectedByName: "William Brown",
      DetectedOn: "2026-08-11T15:30:00+05:30",
      Katashiki: "XYZ-90123",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 136,
      NcApprovedOn: "2026-08-11T16:00:00+05:30",
      WorkApprovedBy: 137,
      WorkApprovedOn: "2026-08-11T17:15:00+05:30",
      CorrectionTime: 55,
      NonConformanceItems: [
        {
          Id: 11,
          Subject: "Connector",
          Item: "Housing",
          BomInfo: "BOM-20003",
          DefectiveItemCount: 2,
          DefectDetail: "Housing deformation found"
        }
      ]
    },
    {
      Id: 1009,
      TrayId: 50009,
      TrayName: "TRAY-50009",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 140,
      DetectedByName: "Olivia Martinez",
      DetectedOn: "2026-08-11T14:20:00+05:30",
      Katashiki: "LMN-67890",
      Kishu: "KISHU-C",
      Status: 0,
      NcApprovedBy: 141,
      NcApprovedOn: "2026-08-11T15:00:00+05:30",
      WorkApprovedBy: 142,
      WorkApprovedOn: "2026-08-11T16:10:00+05:30",
      CorrectionTime: 65,
      NonConformanceItems: [
        {
          Id: 12,
          Subject: "Terminal",
          Item: "Crimp",
          BomInfo: "BOM-30005",
          DefectiveItemCount: 3,
          DefectDetail: "Crimp is loose"
        }
      ]
    },
    {
      Id: 1010,
      TrayId: 50010,
      TrayName: "TRAY-50010",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 145,
      DetectedByName: "Daniel Garcia",
      DetectedOn: "2026-08-11T12:45:00+05:30",
      Katashiki: "ABC-45678",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 146,
      NcApprovedOn: "2026-08-11T13:20:00+05:30",
      WorkApprovedBy: 147,
      WorkApprovedOn: "2026-08-11T14:30:00+05:30",
      CorrectionTime: 25,
      NonConformanceItems: [
        {
          Id: 13,
          Subject: "Cable",
          Item: "Insulation",
          BomInfo: "BOM-10005",
          DefectiveItemCount: 2,
          DefectDetail: "Insulation thickness below specification"
        }
      ]
    },
    {
      Id: 1011,
      TrayId: 50011,
      TrayName: "TRAY-50011",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 150,
      DetectedByName: "Sophia Wilson",
      DetectedOn: "2026-08-10T16:30:00+05:30",
      Katashiki: "XYZ-01234",
      Kishu: "KISHU-B",
      Status: 0,
      NcApprovedBy: 151,
      NcApprovedOn: "2026-08-10T17:00:00+05:30",
      WorkApprovedBy: 152,
      WorkApprovedOn: "2026-08-10T18:00:00+05:30",
      CorrectionTime: 45,
      NonConformanceItems: [
        {
          Id: 14,
          Subject: "Connector",
          Item: "Lock",
          BomInfo: "BOM-20004",
          DefectiveItemCount: 1,
          DefectDetail: "Connector lock mechanism failed"
        }
      ]
    },
    {
      Id: 1012,
      TrayId: 50012,
      TrayName: "TRAY-50012",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 155,
      DetectedByName: "Matthew Taylor",
      DetectedOn: "2026-08-10T15:15:00+05:30",
      Katashiki: "LMN-12345",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 156,
      NcApprovedOn: "2026-08-10T16:00:00+05:30",
      WorkApprovedBy: 157,
      WorkApprovedOn: "2026-08-10T17:20:00+05:30",
      CorrectionTime: 80,
      NonConformanceItems: [
        {
          Id: 15,
          Subject: "Wire",
          Item: "Conductor",
          BomInfo: "BOM-30006",
          DefectiveItemCount: 1,
          DefectDetail: "Conductor resistance above limit"
        }
      ]
    },
    {
      Id: 1013,
      TrayId: 50013,
      TrayName: "TRAY-50013",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 160,
      DetectedByName: "Ava Thomas",
      DetectedOn: "2026-08-10T13:40:00+05:30",
      Katashiki: "ABC-56789",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 161,
      NcApprovedOn: "2026-08-10T14:15:00+05:30",
      WorkApprovedBy: 162,
      WorkApprovedOn: "2026-08-10T15:30:00+05:30",
      CorrectionTime: 30,
      NonConformanceItems: [
        {
          Id: 16,
          Subject: "Terminal",
          Item: "Pin",
          BomInfo: "BOM-10006",
          DefectiveItemCount: 2,
          DefectDetail: "Terminal pin misalignment"
        }
      ]
    },
    {
      Id: 1014,
      TrayId: 50014,
      TrayName: "TRAY-50014",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 165,
      DetectedByName: "Noah Moore",
      DetectedOn: "2026-08-10T11:25:00+05:30",
      Katashiki: "XYZ-12345",
      Kishu: "KISHU-B",
      Status: 0,
      NcApprovedBy: 166,
      NcApprovedOn: "2026-08-10T12:00:00+05:30",
      WorkApprovedBy: 167,
      WorkApprovedOn: "2026-08-10T13:15:00+05:30",
      CorrectionTime: 35,
      NonConformanceItems: [
        {
          Id: 17,
          Subject: "Cable",
          Item: "Connector",
          BomInfo: "BOM-20005",
          DefectiveItemCount: 2,
          DefectDetail: "Cable connector not fully inserted"
        }
      ]
    },
    {
      Id: 1015,
      TrayId: 50015,
      TrayName: "TRAY-50015",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 170,
      DetectedByName: "Isabella Jackson",
      DetectedOn: "2026-08-09T16:10:00+05:30",
      Katashiki: "LMN-23456",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 171,
      NcApprovedOn: "2026-08-09T16:45:00+05:30",
      WorkApprovedBy: 172,
      WorkApprovedOn: "2026-08-09T18:00:00+05:30",
      CorrectionTime: 90,
      NonConformanceItems: [
        {
          Id: 18,
          Subject: "Wire",
          Item: "Terminal",
          BomInfo: "BOM-30007",
          DefectiveItemCount: 3,
          DefectDetail: "Terminal contact resistance high"
        }
      ]
    },
    {
      Id: 1016,
      TrayId: 50016,
      TrayName: "TRAY-50016",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 175,
      DetectedByName: "Ethan White",
      DetectedOn: "2026-08-09T14:35:00+05:30",
      Katashiki: "ABC-67890",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 176,
      NcApprovedOn: "2026-08-09T15:10:00+05:30",
      WorkApprovedBy: 177,
      WorkApprovedOn: "2026-08-09T16:25:00+05:30",
      CorrectionTime: 40,
      NonConformanceItems: [
        {
          Id: 19,
          Subject: "Cable",
          Item: "Insulation",
          BomInfo: "BOM-10007",
          DefectiveItemCount: 1,
          DefectDetail: "Insulation surface scratched"
        }
      ]
    },
    {
      Id: 1017,
      TrayId: 50017,
      TrayName: "TRAY-50017",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 180,
      DetectedByName: "Mia Harris",
      DetectedOn: "2026-08-09T12:20:00+05:30",
      Katashiki: "XYZ-23456",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 181,
      NcApprovedOn: "2026-08-09T13:00:00+05:30",
      WorkApprovedBy: 182,
      WorkApprovedOn: "2026-08-09T14:10:00+05:30",
      CorrectionTime: 50,
      NonConformanceItems: [
        {
          Id: 20,
          Subject: "Connector",
          Item: "Housing",
          BomInfo: "BOM-20006",
          DefectiveItemCount: 1,
          DefectDetail: "Housing color variation"
        }
      ]
    },
    {
      Id: 1018,
      TrayId: 50018,
      TrayName: "TRAY-50018",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 185,
      DetectedByName: "Lucas Martin",
      DetectedOn: "2026-08-08T17:05:00+05:30",
      Katashiki: "LMN-34567",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 186,
      NcApprovedOn: "2026-08-08T17:40:00+05:30",
      WorkApprovedBy: 187,
      WorkApprovedOn: "2026-08-08T19:00:00+05:30",
      CorrectionTime: 75,
      NonConformanceItems: [
        {
          Id: 21,
          Subject: "Terminal",
          Item: "Crimp",
          BomInfo: "BOM-30008",
          DefectiveItemCount: 2,
          DefectDetail: "Crimp pull strength below specification"
        }
      ]
    },
    {
      Id: 1019,
      TrayId: 50019,
      TrayName: "TRAY-50019",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 190,
      DetectedByName: "Charlotte Thompson",
      DetectedOn: "2026-08-08T15:45:00+05:30",
      Katashiki: "ABC-78901",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 191,
      NcApprovedOn: "2026-08-08T16:20:00+05:30",
      WorkApprovedBy: 192,
      WorkApprovedOn: "2026-08-08T17:30:00+05:30",
      CorrectionTime: 20,
      NonConformanceItems: [
        {
          Id: 22,
          Subject: "Wire",
          Item: "Conductor",
          BomInfo: "BOM-10008",
          DefectiveItemCount: 2,
          DefectDetail: "Wire length out of tolerance"
        }
      ]
    },
    {
      Id: 1020,
      TrayId: 50020,
      TrayName: "TRAY-50020",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 195,
      DetectedByName: "Henry Garcia",
      DetectedOn: "2026-08-08T13:30:00+05:30",
      Katashiki: "XYZ-34567",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 196,
      NcApprovedOn: "2026-08-08T14:10:00+05:30",
      WorkApprovedBy: 197,
      WorkApprovedOn: "2026-08-08T15:20:00+05:30",
      CorrectionTime: 45,
      NonConformanceItems: [
        {
          Id: 23,
          Subject: "Connector",
          Item: "Pin",
          BomInfo: "BOM-20007",
          DefectiveItemCount: 3,
          DefectDetail: "Pin insertion depth incorrect"
        }
      ]
    },
    {
      Id: 1021,
      TrayId: 50021,
      TrayName: "TRAY-50021",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 200,
      DetectedByName: "Amelia Martinez",
      DetectedOn: "2026-08-08T11:15:00+05:30",
      Katashiki: "LMN-45678",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 201,
      NcApprovedOn: "2026-08-08T12:00:00+05:30",
      WorkApprovedBy: 202,
      WorkApprovedOn: "2026-08-08T13:30:00+05:30",
      CorrectionTime: 100,
      NonConformanceItems: [
        {
          Id: 24,
          Subject: "Cable",
          Item: "Shield",
          BomInfo: "BOM-30009",
          DefectiveItemCount: 1,
          DefectDetail: "Shield connection incomplete"
        }
      ]
    },
    {
      Id: 1022,
      TrayId: 50022,
      TrayName: "TRAY-50022",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 205,
      DetectedByName: "Alexander Robinson",
      DetectedOn: "2026-08-07T16:50:00+05:30",
      Katashiki: "ABC-89012",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 206,
      NcApprovedOn: "2026-08-07T17:20:00+05:30",
      WorkApprovedBy: 207,
      WorkApprovedOn: "2026-08-07T18:15:00+05:30",
      CorrectionTime: 35,
      NonConformanceItems: [
        {
          Id: 25,
          Subject: "Terminal",
          Item: "Lock",
          BomInfo: "BOM-10009",
          DefectiveItemCount: 1,
          DefectDetail: "Terminal locking tab broken"
        }
      ]
    },
    {
      Id: 1023,
      TrayId: 50023,
      TrayName: "TRAY-50023",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 210,
      DetectedByName: "Evelyn Clark",
      DetectedOn: "2026-08-07T14:25:00+05:30",
      Katashiki: "XYZ-45678",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 211,
      NcApprovedOn: "2026-08-07T15:00:00+05:30",
      WorkApprovedBy: 212,
      WorkApprovedOn: "2026-08-07T16:15:00+05:30",
      CorrectionTime: 60,
      NonConformanceItems: [
        {
          Id: 26,
          Subject: "Connector",
          Item: "Terminal",
          BomInfo: "BOM-20008",
          DefectiveItemCount: 2,
          DefectDetail: "Connector terminal bent"
        }
      ]
    },
    {
      Id: 1024,
      TrayId: 50024,
      TrayName: "TRAY-50024",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 215,
      DetectedByName: "Benjamin Lewis",
      DetectedOn: "2026-08-07T12:10:00+05:30",
      Katashiki: "LMN-56789",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 216,
      NcApprovedOn: "2026-08-07T12:45:00+05:30",
      WorkApprovedBy: 217,
      WorkApprovedOn: "2026-08-07T14:00:00+05:30",
      CorrectionTime: 85,
      NonConformanceItems: [
        {
          Id: 27,
          Subject: "Wire",
          Item: "Conductor",
          BomInfo: "BOM-30010",
          DefectiveItemCount: 2,
          DefectDetail: "Conductor insulation resistance failure"
        }
      ]
    },
    {
      Id: 1025,
      TrayId: 50025,
      TrayName: "TRAY-50025",
      DetectionProcessId: 10,
      DetectionProcessName: "Cutting",
      ReturProcessId: 20,
      ReturProcessName: "Inspection",
      DetectedBy: 220,
      DetectedByName: "Harper Walker",
      DetectedOn: "2026-08-06T16:35:00+05:30",
      Katashiki: "ABC-90123",
      Kishu: "KISHU-A",
      Status: 1,
      NcApprovedBy: 221,
      NcApprovedOn: "2026-08-06T17:10:00+05:30",
      WorkApprovedBy: 222,
      WorkApprovedOn: "2026-08-06T18:20:00+05:30",
      CorrectionTime: 30,
      NonConformanceItems: [
        {
          Id: 28,
          Subject: "Cable",
          Item: "Jacket",
          BomInfo: "BOM-10010",
          DefectiveItemCount: 1,
          DefectDetail: "Jacket dimension out of tolerance"
        }
      ]
    },
    {
      Id: 1026,
      TrayId: 50026,
      TrayName: "TRAY-50026",
      DetectionProcessId: 15,
      DetectionProcessName: "Assembly",
      ReturProcessId: 25,
      ReturProcessName: "Electrical Inspection",
      DetectedBy: 225,
      DetectedByName: "Sebastian Hall",
      DetectedOn: "2026-08-06T14:40:00+05:30",
      Katashiki: "XYZ-56789",
      Kishu: "KISHU-B",
      Status: 2,
      NcApprovedBy: 226,
      NcApprovedOn: "2026-08-06T15:15:00+05:30",
      WorkApprovedBy: 227,
      WorkApprovedOn: "2026-08-06T16:30:00+05:30",
      CorrectionTime: 40,
      NonConformanceItems: [
        {
          Id: 29,
          Subject: "Connector",
          Item: "Housing",
          BomInfo: "BOM-20009",
          DefectiveItemCount: 1,
          DefectDetail: "Housing assembly incomplete"
        }
      ]
    },
    {
      Id: 1027,
      TrayId: 50027,
      TrayName: "TRAY-50027",
      DetectionProcessId: 30,
      DetectionProcessName: "Electrical Inspection",
      ReturProcessId: 40,
      ReturProcessName: "Rework",
      DetectedBy: 230,
      DetectedByName: "Ella Allen",
      DetectedOn: "2026-08-06T12:25:00+05:30",
      Katashiki: "LMN-67890",
      Kishu: "KISHU-C",
      Status: 1,
      NcApprovedBy: 231,
      NcApprovedOn: "2026-08-06T13:00:00+05:30",
      WorkApprovedBy: 232,
      WorkApprovedOn: "2026-08-06T14:20:00+05:30",
      CorrectionTime: 95,
      NonConformanceItems: [
        {
          Id: 30,
          Subject: "Terminal",
          Item: "Crimp",
          BomInfo: "BOM-30011",
          DefectiveItemCount: 2,
          DefectDetail: "Crimp alignment is incorrect"
        }
      ]
    }
  ],

  PagingDetails: {
    PageNumber: 1,
    PageSize: 30,
    TotalRecords: 30,
    TotalPages: 1
  }
};

/**
 * Mock response for ToolManagement/GetCrimpToolInspectionList, matching the real API's
 * ToolCrimpInspectionList shape field-for-field. Used as a fallback by
 * GetToolCrimpInspectionListService when the API call fails, so the Crimping Inspection
 * Record List module always has data to display.
 */
export const mockToolCrimpInspectionListResponse = {
  Error: false,
  Message: '',
  Data: {
    CrimpInspection: [
      {
        Id: 1,
        ToolId: 101,
        StartDate: '2026-06-02T11:22:00',
        EndDate: '2026-06-02T11:24:00',
        Duration: 120,
        State: 1,
        Awg: '22',
        UpperLimit: 1.45,
        LowerLimit: 1.25,
        TensileStrength: 54,
        TemplateValues: '{"ch":1.35}',
        CalculatedResult: 0,
        NgReason: 'Over-crimping suspected',
        CreatedAt: '2026-06-02T11:24:00',
        CreatedBy: 12,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 2,
        ToolId: 102,
        StartDate: '2026-06-02T13:46:00',
        EndDate: '2026-06-02T13:47:30',
        Duration: 90,
        State: 1,
        Awg: '20',
        UpperLimit: 1.15,
        LowerLimit: 0.95,
        TensileStrength: 68,
        TemplateValues: '{"ch":1.06}',
        CalculatedResult: 1,
        NgReason: null,
        CreatedAt: '2026-06-02T13:47:30',
        CreatedBy: 8,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 3,
        ToolId: 103,
        StartDate: '2026-06-02T12:31:00',
        EndDate: '2026-06-02T12:33:10',
        Duration: 130,
        State: 1,
        Awg: '18',
        UpperLimit: 1.6,
        LowerLimit: 1.4,
        TensileStrength: 72,
        TemplateValues: '{"ch":1.5}',
        CalculatedResult: 1,
        NgReason: null,
        CreatedAt: '2026-06-02T12:33:10',
        CreatedBy: 12,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 4,
        ToolId: 101,
        StartDate: '2026-06-03T09:12:00',
        EndDate: '2026-06-03T09:13:40',
        Duration: 100,
        State: 1,
        Awg: '22',
        UpperLimit: 1.45,
        LowerLimit: 1.25,
        TensileStrength: 49,
        TemplateValues: '{"ch":1.12}',
        CalculatedResult: 0,
        NgReason: 'Tensile strength below limit',
        CreatedAt: '2026-06-03T09:13:40',
        CreatedBy: 8,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 5,
        ToolId: 104,
        StartDate: '2026-06-03T10:05:00',
        EndDate: '2026-06-03T10:06:20',
        Duration: 80,
        State: 1,
        Awg: '24',
        UpperLimit: 0.95,
        LowerLimit: 0.75,
        TensileStrength: 40,
        TemplateValues: '{"ch":0.86}',
        CalculatedResult: 1,
        NgReason: null,
        CreatedAt: '2026-06-03T10:06:20',
        CreatedBy: 15,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 6,
        ToolId: 102,
        StartDate: '2026-06-04T14:18:00',
        EndDate: '2026-06-04T14:19:45',
        Duration: 105,
        State: 1,
        Awg: '20',
        UpperLimit: 1.15,
        LowerLimit: 0.95,
        TensileStrength: 65,
        TemplateValues: '{"ch":1.02}',
        CalculatedResult: 1,
        NgReason: null,
        CreatedAt: '2026-06-04T14:19:45',
        CreatedBy: 12,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 7,
        ToolId: 105,
        StartDate: '2026-06-04T15:40:00',
        EndDate: '2026-06-04T15:41:30',
        Duration: 90,
        State: 1,
        Awg: '16',
        UpperLimit: 1.9,
        LowerLimit: 1.7,
        TensileStrength: 88,
        TemplateValues: '{"ch":1.82}',
        CalculatedResult: 0,
        NgReason: 'Shape check failed',
        CreatedAt: '2026-06-04T15:41:30',
        CreatedBy: 8,
        UpdatedAt: null,
        UpdatedBy: null,
      },
      {
        Id: 8,
        ToolId: 103,
        StartDate: '2026-06-05T08:52:00',
        EndDate: '2026-06-05T08:53:15',
        Duration: 75,
        State: 1,
        Awg: '18',
        UpperLimit: 1.6,
        LowerLimit: 1.4,
        TensileStrength: 70,
        TemplateValues: '{"ch":1.48}',
        CalculatedResult: 1,
        NgReason: null,
        CreatedAt: '2026-06-05T08:53:15',
        CreatedBy: 15,
        UpdatedAt: null,
        UpdatedBy: null,
      },
    ],
    PagingDetails: {
      TotalRecords: 84,
      TotalPages: 11,
      CurrentPage: 1,
      PageSize: 8,
    },
  },
};

/**
 * Mock response for ToolManagement/GetUserInspectedList, matching the real API's
 * ToolCheckInfoMasterList shape field-for-field. Used as a fallback by
 * GetUserInspectedListService when the API call fails, so the User Created Inspection
 * Record List module always has data to display.
 */
export const mockUserInspectedListResponse = {
  Error: false,
  Message: '',
  Data: {
    ToolCheckInfoMasterLists: [
      {
        Id: 1,
        ToolId: 201,
        StartDate: '2026-06-02T09:00:00',
        EndDate: '2026-06-02T09:08:00',
        Duration: 480,
        State: 1,
        InspectionResult: 0,
        NgReason: null,
        CreatedAt: '2026-06-02T09:08:00',
        CreatedBy: 9,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 2,
        ToolId: 202,
        StartDate: '2026-06-02T10:15:00',
        EndDate: '2026-06-02T10:21:00',
        Duration: 360,
        State: 1,
        InspectionResult: 1,
        NgReason: 'Visible wear on applicator tip',
        CreatedAt: '2026-06-02T10:21:00',
        CreatedBy: 11,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 3,
        ToolId: 203,
        StartDate: '2026-06-03T08:30:00',
        EndDate: '2026-06-03T08:36:00',
        Duration: 360,
        State: 1,
        InspectionResult: 0,
        NgReason: null,
        CreatedAt: '2026-06-03T08:36:00',
        CreatedBy: 9,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 4,
        ToolId: 201,
        StartDate: '2026-06-03T13:05:00',
        EndDate: '2026-06-03T13:12:00',
        Duration: 420,
        State: 1,
        InspectionResult: 0,
        NgReason: null,
        CreatedAt: '2026-06-03T13:12:00',
        CreatedBy: 14,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 5,
        ToolId: 204,
        StartDate: '2026-06-04T09:45:00',
        EndDate: '2026-06-04T09:50:00',
        Duration: 300,
        State: 1,
        InspectionResult: 1,
        NgReason: 'Loose mounting screw',
        CreatedAt: '2026-06-04T09:50:00',
        CreatedBy: 11,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 6,
        ToolId: 202,
        StartDate: '2026-06-04T14:00:00',
        EndDate: '2026-06-04T14:07:00',
        Duration: 420,
        State: 1,
        InspectionResult: 0,
        NgReason: null,
        CreatedAt: '2026-06-04T14:07:00',
        CreatedBy: 9,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 7,
        ToolId: 205,
        StartDate: '2026-06-05T11:20:00',
        EndDate: '2026-06-05T11:25:00',
        Duration: 300,
        State: 1,
        InspectionResult: 0,
        NgReason: null,
        CreatedAt: '2026-06-05T11:25:00',
        CreatedBy: 14,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
      {
        Id: 8,
        ToolId: 203,
        StartDate: '2026-06-05T15:35:00',
        EndDate: '2026-06-05T15:41:00',
        Duration: 360,
        State: 1,
        InspectionResult: 1,
        NgReason: 'Terminal misalignment',
        CreatedAt: '2026-06-05T15:41:00',
        CreatedBy: 11,
        UpdatedAt: null,
        UpdatedBy: null,
        ToolCheckItemDataList: [],
      },
    ],
    PagingDetails: {
      TotalRecords: 62,
      TotalPages: 8,
      CurrentPage: 1,
      PageSize: 8,
    },
  },
};

export interface NcDatum {
  name: string
  count: number
}
 
// --- By Process tab -----------------------------------------------------
export const byProcessData: NcDatum[] = [
  { name: "組立", count: 9 },
  { name: "部品処理", count: 5 },
  { name: "切断", count: 4 },
  { name: "圧着", count: 1 },
]
 
// --- Sub Contractor tab --------------------------------------------------
export const subContractorData: NcDatum[] = [
  { name: "ケーブル社内", count: 12 },
  { name: "岩本工業", count: 4 },
  { name: "ワンダーランド", count: 3 },
]
 
// --- Item tab -------------------------------------------------------------
// Raw, unsorted item counts. The ItemChart component takes the top 10 by
// count and buckets everything else into "その他" (Others).
export const itemData: NcDatum[] = [
  { name: "半挿入", count: 3 },
  { name: "未切断", count: 3 },
  { name: "誤配", count: 2 },
  { name: "突っ張り", count: 2 },
  { name: "切断長違い", count: 2 },
  { name: "不要線カットミス", count: 2 },
  { name: "芯線キズ", count: 1 },
  { name: "ストリップミス", count: 1 },
  { name: "部品組付け不良", count: 1 },
  { name: "マークチューブミス", count: 1 },
  { name: "端子間違い", count: 1 },
  { name: "ねじなめ", count: 1 },
]


export const ncrMockData: any = [
  {
    detectionDate: "2025/8/29",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/8/27",
    workProcess: "Cable In-house",
    operator: "Souda",
    inspector: "T&B",
    productNo: "2508-01507-00/02",
    model: "DTEG18531-005/03/06/CN9-A1B",
    qty: 1,
    defectItem: "Not recorded",
    defectDetails: "Connector tip too short (WHBU wire too long)",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/29",
    detectionProcess: "Inspection",
    detectedBy: "Nishino",
    workDate: "2025/8/27",
    workProcess: "Crimping",
    operator: "Souda",
    inspector: "T&B",
    productNo: "2508-01160-00/02",
    model: "DTEG18123-003/02/06/CN6-BR5AV",
    qty: 1,
    defectItem: "Half insertion",
    defectDetails: "Label hole H80A-C, label sheet present",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/29",
    detectionProcess: "Inspection",
    detectedBy: "Nishino",
    workDate: "2025/8/27",
    workProcess: "Pre-processing",
    operator: "QHT2",
    inspector: "QHT2",
    productNo: "2508-01162-00/02",
    model: "DTEG18124-003/02/03/CN2-BR3SV",
    qty: 1,
    defectItem: "Wrong crimp attachment",
    defectDetails: "Label hole PKH1-HT, clear protective tape missing",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/29",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/8/27",
    workProcess: "Cable In-house",
    operator: "Souda",
    inspector: "T&B",
    productNo: "2508-01188-00/02",
    model: "DTEG13207-001/04/06/CN6-BR5QV",
    qty: 1,
    defectItem: "Mark tube mistake",
    defectDetails: "Pre-processing defect TB122-EH, not set in the set list",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/9/6",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/9/4",
    workProcess: "Iwamoto Industry",
    operator: "",
    inspector: "",
    productNo: "2508-02155-00/02",
    model: "DTEG13954-009/01/07/CN5-A1B",
    qty: 1,
    defectItem: "Unnecessary bundle cut mistake",
    defectDetails: "Connector defect CN7-A3 white rod, sagging",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/9/6",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/9/4",
    workProcess: "Iwamoto Industry",
    operator: "",
    inspector: "",
    productNo: "2508-03645-00/02",
    model: "DTEG10525-003/02/06/F10J-33M",
    qty: 1,
    defectItem: "Not recorded",
    defectDetails: "Electronic fitting HPC-SUC, harness has burr",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/9/6",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/9/4",
    workProcess: "Iwamoto Industry",
    operator: "QHT2",
    inspector: "QHT2",
    productNo: "2508-00256-00/02",
    model: "DTEG10598-003/01/00/F30R1078SU",
    qty: 1,
    defectItem: "Loose screw",
    defectDetails: "Terminal PPW2-CTS02 (black) and 3 (white) inserted in reverse",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/29",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/8/27",
    workProcess: "Cable In-house",
    operator: "QHT2",
    inspector: "QHT2",
    productNo: "2508-03111-000/02/00",
    model: "PHP7-EHA",
    qty: 1,
    defectItem: "Full length cut off",
    defectDetails: "Misalignment PSE5C lower stage, PDBR10MC harness misaligned",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/29",
    detectionProcess: "Inspection",
    detectedBy: "Nishino",
    workDate: "",
    workProcess: "",
    operator: "",
    inspector: "",
    productNo: "",
    model: "",
    qty: 1,
    defectItem: "Electronic appearance mistake",
    defectDetails: "Sagging seen at drain wire near connector tip",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/9/7",
    detectionProcess: "Enami",
    detectedBy: "Nishino",
    workDate: "2025/9/5",
    workProcess: "Pre-processing",
    operator: "QAUN",
    inspector: "QAUN",
    productNo: "2508-00679-00/02",
    model: "DTEG18999-000/01/03/U6E1MAIN F",
    qty: 1,
    defectItem: "Scratch defect",
    defectDetails: "Pre-processing defect CC0N1 white sheath strip end torn (back side)",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/30",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/9/4",
    workProcess: "Pre-processing",
    operator: "QAUN",
    inspector: "QAUN",
    productNo: "2508-03925-00/02",
    model: "DTEG18999-000/01/03/U6E1MAIN F",
    qty: 1,
    defectItem: "Wrong placement",
    defectDetails: "Label APD/PMAD1 attachment position shifted",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/8/30",
    detectionProcess: "Pre-processing",
    detectedBy: "Nishino",
    workDate: "2025/8/28",
    workProcess: "Pre-processing",
    operator: "QAUN",
    inspector: "QAUN",
    productNo: "2508-04077-00/02",
    model: "DTEG18999-000/01/03/U6E1MAIN F",
    qty: 1,
    defectItem: "Wire length wrong",
    defectDetails: "Connector ROM-SUS3 (blue) and UW-BU inserted in reverse",
    correctionCount: 300,
  },
  {
    detectionDate: "2025/9/7",
    detectionProcess: "Inspection",
    detectedBy: "Nishino",
    workDate: "2025/9/5",
    workProcess: "Iwamoto Industry",
    operator: "",
    inspector: "",
    productNo: "2508-01531-00/02",
    model: "DTEG13924-000/02/03/CN9-A2D/T1",
    qty: 1,
    defectItem: "Misalignment",
    defectDetails: "Total length (S800+100) is 5-8mm shorter than spec",
    correctionCount: 300,
  },
]